import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalComponent } from 'app/components/modal/modal.component';
import { AuthService } from 'app/services/auth.service';
import { ModalService } from 'app/services/modal.service';
import { PresentationService } from 'app/services/presentation/presentation.service';
import { ScheduleEntryModel } from 'app/views/devices/models/scheduleEntry.model';
import { PresentationModel } from 'app/views/presentations/models/presentation.model';

@Component({
    selector: 'psm-edit-schedule-entry-modal',
    templateUrl: 'editScheduleEntryModal.component.html',
    styleUrls: ['editScheduleEntryModal.component.scss']
})
export class EditScheduleEntryModalComponent extends ModalComponent<ScheduleEntryModel> implements OnInit {

    public inputScheduleEntry: ScheduleEntryModel;

    public presentations: PresentationModel[];
    private presentationDictionary: {};

    public presentation: PresentationModel; // view purpose only
    public thumbnailPath: string;

    public form: FormGroup;
    public presentationId: FormControl;
    public startDate: FormControl;
    public endDate: FormControl;

    private async getPresentations() {
        let user = await this.authService.getCurrentUser();
        this.presentations = await this.presentationService.getUserPresentationList(user.uid);

        this.presentationDictionary = {};
        for (let pres of this.presentations) {
            this.presentationDictionary[pres.id] = pres;
        }
    }

    constructor(modalService: ModalService, router: Router, private authService: AuthService, private presentationService: PresentationService) {
        super(modalService, router);
    }

    public async ngOnInit() {
        await this.getPresentations();
        if (this.inputScheduleEntry.presentationId) {
            await this.updateSelectedPresentation(this.inputScheduleEntry.presentationId);
        }
    }

    private validateStartDate(startDateControl: AbstractControl): ValidationErrors | null {
        if (this.endDate && startDateControl.value > this.endDate.value) return { overlap: 'true' };
        return null;
    }

    private validateEndDate(endDateControl: AbstractControl): ValidationErrors | null {
        if (this.startDate && endDateControl.value < this.startDate.value) return { overlap: 'true' };
        return null;
    }

    // override
    protected onOpen() {
        if (!this.inputScheduleEntry.presentationId) {
            this.presentation = undefined;
        }

        this.presentationId = new FormControl(this.inputScheduleEntry.presentationId, [Validators.required]);
        this.startDate = new FormControl(new Date(this.inputScheduleEntry.startDate), [Validators.required, x => this.validateStartDate(x)]);
        this.endDate = new FormControl(new Date(this.inputScheduleEntry.endDate), [Validators.required, x => this.validateEndDate(x)]);

        this.form = new FormGroup({
            presentationId: this.presentationId,
            startDate: this.startDate,
            endDate: this.endDate
        });
    }

    public onAcceptAction() {
        if (this.form.valid) {
            let returnedscheduleEntry = new ScheduleEntryModel(this.presentationId.value, (this.startDate.value).getTime(), (this.endDate.value).getTime());

            this.close(returnedscheduleEntry);
        }
    }

    public async updateSelectedPresentation(id: string) {
        this.presentation = this.presentationDictionary[id];
        this.thumbnailPath = await this.presentationService.getThumbnailUrl(this.presentation);
    }

    public onCloseClicked() {
        this.close(undefined);
    }

    // override
    protected onNavigation() {
        this.close(undefined);
    }

    public onStartDateChange(event) {
        this.startDate.markAsDirty();
        this.endDate.updateValueAndValidity();
    }

    public onEndDateChange(event) {
        this.endDate.markAsDirty();
        this.startDate.updateValueAndValidity();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/editScheduleEntryModal/editScheduleEntryModal.component.ts